export const USER_NOTIFICATIONS_FETCH_STARTED = 'USER_NOTIFICATIONS_FETCH_STARTED';
export const USER_NOTIFICATIONS_FETCH_COMPLETED = 'USER_NOTIFICATIONS_FETCH_COMPLETED';
export const USER_NOTIFICATIONS_FETCH_FAILED = 'USER_NOTIFICATIONS_FETCH_FAILED';

export const USER_NOTIFICATIONS_PARTIAL_FETCH_STARTED = 'USER_NOTIFICATIONS_PARTIAL_FETCH_STARTED';
export const USER_NOTIFICATIONS_PARTIAL_FETCH_COMPLETED =
  'USER_NOTIFICATIONS_PARTIAL_FETCH_COMPLETED';
export const USER_NOTIFICATIONS_PARTIAL_FETCH_FAILED = 'USER_NOTIFICATIONS_PARTIAL_FETCH_FAILED';

export const USER_NOTIFICATION_READ_STARTED = 'USER_NOTIFICATION_READ_STARTED';
export const USER_NOTIFICATION_READ_COMPLETED = 'USER_NOTIFICATION_READ_COMPLETED';
export const USER_NOTIFICATION_READ_FAILED = 'USER_NOTIFICATION_READ_FAILED';

export const SYSTEM_NOTIFICATION_READ_STARTED = 'SYSTEM_NOTIFICATION_READ_STARTED';
export const SYSTEM_NOTIFICATION_READ_COMPLETED = 'SYSTEM_NOTIFICATION_READ_COMPLETED';
export const SYSTEM_NOTIFICATION_READ_FAILED = 'SYSTEM_NOTIFICATION_READ_FAILED';

export const USER_NOTIFICATION_FORWARD_STARTED = 'USER_NOTIFICATION_FORWARD_STARTED';
export const USER_NOTIFICATION_FORWARD_COMPLETED = 'USER_NOTIFICATION_FORWARD_COMPLETED';
export const USER_NOTIFICATION_FORWARD_FAILED = 'USER_NOTIFICATION_FORWARD_FAILED';

export const USER_NOTIFICATION_SHOWN = 'USER_NOTIFICATION_SHOWN';
export const USER_NOTIFICATION_UNSHOWN = 'USER_NOTIFICATION_UNSHOWN';

export const USER_NOTIFICATION_SELECTED = 'USER_NOTIFICATION_SELECTED';
export const USER_NOTIFICATION_DESELECTED = 'SYSTEM_NOTIFICATION_USER_DESELECTED';
export const USER_NOTIFICATION_ALL_SELECTED = 'USER_NOTIFICATION_ALL_SELECTED';
export const USER_NOTIFICATION_ALL_DESELECTED = 'USER_NOTIFICATION_ALL_DESELECTED';

export const USER_PUSH_NOTIFICATIONS_FETCH_COMPLETED = 'USER_PUSH_NOTIFICATIONS_FETCH_COMPLETED';

export interface UserNotification {
  isSelected: boolean;
  isConfirmed: boolean;
  shownAtLogin: boolean;
  systemNotificationId: number;
  notificationId: number;
  messageType: number;
  messageTitle: number;
  message: string;
  startDate: string;
  endDate: string;
  entityTypeId: number;
  operatorId: number;
  organizationId: number;
  accessLevelId: number;
  userId: number;
  mobileOperatorId: number;
  status: number;
  useToast: boolean;
  toastTime: number;
  isWebtrackNotification: boolean;
  notificationType?: number;
  bannerDesktopImageUrl?: string;
  bannerMobileImageUrl?: string;
  redirectUrl?: string;
}
